const EMPTY_OBJ = Object.freeze({});

export function normalizeFeatureResponse(input) {
    const raw = input && typeof input === 'object' ? input : EMPTY_OBJ;

    const flags = {};

    for (const key of Object.keys(raw)) {
        flags[key] = raw[key]?.main_setting?.enable === true;
    }

    return { flags, raw };
}
